import { useState } from 'react';
import { Link, NavLink, Outlet, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../context/AuthContext';
import BrandMark from './BrandMark';
import LanguageSwitcher from './LanguageSwitcher';

const API_BASE = process.env.REACT_APP_API_BASE || '';

export default function PortalLayout({ links }) {
  const { t } = useTranslation();
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

  const roleLabel = user?.role === 'nanny' ? t('portal.nannyPortal') : t('portal.familyPortal');

  function signOut() {
    logout();
    navigate('/');
  }

  const initials = `${user?.firstName?.[0] || ''}${user?.lastName?.[0] || ''}`.toUpperCase();

  return (
    <div className="portal">
      <aside className={`portal-nav ${menuOpen ? 'open' : ''}`}>
        <Link to="/" className="portal-brand">
          <BrandMark />
          <span>
            <strong>Nannies to the Rescue</strong>
            <small>{roleLabel}</small>
          </span>
        </Link>

        <nav>
          {links.map((link) => (
            <NavLink
              key={link.to}
              to={link.to}
              end={link.end}
              onClick={() => setMenuOpen(false)}
              className={({ isActive }) => (isActive ? 'nav-item active' : 'nav-item')}
            >
              <span className="nav-icon" aria-hidden="true">{link.icon}</span>
              {link.label}
            </NavLink>
          ))}
        </nav>

        <LanguageSwitcher className="lang-switcher-portal" />

        <div className="portal-user">
          {user?.avatarUrl ? (
            <span className="avatar"><img src={`${API_BASE}${user.avatarUrl}`} alt="" /></span>
          ) : (
            <span className="avatar">{initials || '?'}</span>
          )}
          <div>
            <strong>{user?.fullName}</strong>
            <small>{user?.email}</small>
          </div>
        </div>
        <button type="button" className="btn btn-ghost btn-block" onClick={signOut}>
          {t('portal.signOut')}
        </button>
      </aside>

      <div className="portal-main">
        <header className="portal-topbar">
          <button
            type="button"
            className="menu-toggle"
            onClick={() => setMenuOpen((v) => !v)}
            aria-label={t('portal.toggleNav')}
          >
            ☰
          </button>
          <span className="topbar-title">{roleLabel}</span>
          <Link to="/" className="topbar-link">{t('portal.home')}</Link>
        </header>
        <main className="portal-content">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
